const NUMBER_FORMATTER = new Intl.NumberFormat('en-US', {
	style: 'decimal',
	maximumFractionDigits: 0
});

const CURRENCY_FORMATTER = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD'
});

const CURRENCY_NO_DECIMALS_FORMATTER = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	maximumFractionDigits: 0
});

const DECIMAL_FORMATTER = new Intl.NumberFormat('en-US', {
	style: 'decimal',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
});

const PERCENT_FORMATTER = new Intl.NumberFormat('en-US', {
	style: 'percent'
});

const PERCENT_2_DECIMALS_FORMATTER = new Intl.NumberFormat('en-US', {
	style: 'percent',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
});

const PERCENT_1_DECIMAL_FORMATTER = new Intl.NumberFormat('en-US', {
	style: 'percent',
	minimumFractionDigits: 1,
	maximumFractionDigits: 1
})

export default {
	methods: {
		sum(...values) {

			return values.reduce((accumulator, currentValue) => accumulator + (!currentValue ? 0 : Number(currentValue)), 0);
		},
		sumText(...values) {

			// The last element passed is the value to check for summation
			let sumValues = values.pop();

			return values.reduce((accumulator, currentValue) => accumulator + (isNaN(currentValue) ? (sumValues.includes(currentValue) ? 1 : 0) : currentValue), 0);
		},
		arrayPush(...values) {
			//removing 0 from the list as that is passed for all other operators for the summary row
			return values.reduce((accumulator, currentValue) => [...accumulator, currentValue], []).flat();
		},
		findIndex(arr, criteria, value) {
			return arr ? arr.findIndex(el => el[criteria] == value) : -1;
		},
		dataFormatter(value, arg) {

			switch (arg) {
				case 'number':
					return NUMBER_FORMATTER.format(value || 0);
				case 'currency':
					return CURRENCY_FORMATTER.format(value || 0);
				case 'currency-no-decimals':
					return CURRENCY_NO_DECIMALS_FORMATTER.format(value || 0);
				case 'decimal':
					return DECIMAL_FORMATTER.format(value || 0);
				case 'percent':
					return PERCENT_FORMATTER.format(value || 0);
				case 'percent-2-decimals':
					return PERCENT_2_DECIMALS_FORMATTER.format(value || 0);
				case 'percent-1-decimal':
					return PERCENT_1_DECIMAL_FORMATTER.format(value || 0);
			}
			return value;
		},
	}
};
